import IntranetSearchClient from "./intranetSearch/clients/IntranetSearchClient";
import { IntranetLayersParams, IntranetLayers } from "./intranetSearch/models/intranet-search";
import { peopleResponseMockEn, peopleResponseMockRu } from "./suggestPeopleResponseMock";
import {
    departmentResponseMockRu,
    departmentResponseMockEn
} from "./suggestDepartmentResponseMock";

const searchApi = new IntranetSearchClient();

/**
 * Using API for suggestions
 * https://wiki.yandex-team.ru/intranetpoisk/suggest/api/
 */
export const requestStaffSuggestions = async (layers: IntranetLayersParams, text: string) => {
    let response = undefined;
    try {
        response = await searchApi.suggest({
            text,
            layers,
        });
    } catch (error) {
        console.error(error);
    }

    return response?.data;
}

/**
 * Поиск результатов согласно набранному тексту
 * Request GET (example): https://search.yandex-team.ru/suggest?layers=people&people.query=i_is_dismissed:0&perPage=30&text=
 */
export const requestStaffPeople = async (text: string, language = "ru", perPage = 30, page = 0) => {
    if (process.env.NODE_ENV === "development" && !!process.env.FAST_REFRESH) {
        return Promise.resolve(language === 'ru' ? peopleResponseMockRu : peopleResponseMockEn);
    }

    return await requestStaffSuggestions({
        [IntranetLayers.People]: {
            language: language,
            query: "i_is_dismissed:0", // исключены бывшие сотрудники
            perPage: perPage,
            page: page
        }
    }, text)
}

/**
 * Поиск результатов согласно набранному тексту
 * Request GET (example): https://search.yandex-team.ru/suggest/?version=2&layers=groups&groups.query=s_type:department&text=
 */
export const requestStaffDepartment = async (text: string, language = "ru", perPage = 30, page = 0) => {
    if (process.env.NODE_ENV === 'development' && !!process.env.FAST_REFRESH) {
        return Promise.resolve(language === 'ru' ? departmentResponseMockRu : departmentResponseMockEn);
    }

    return await requestStaffSuggestions({
        [IntranetLayers.Groups]: {
            language: language,
            query: "s_type:department", // только подразделения (департаменты)
            perPage: perPage,
            page: page
        }
    }, text)
}

export const getUserByLogin = async (login: string, language = "ru", perPage = 5, page = 0) => {
    if (process.env.NODE_ENV === "development" && !!process.env.FAST_REFRESH) {
        return Promise.resolve(language === 'ru' ? peopleResponseMockRu : peopleResponseMockEn);
    }

    return await requestStaffSuggestions({
            [IntranetLayers.People]: {
                language: language,
                perPage: perPage,
                page: page,
                exactMatch: [login],
            }
        }, login
    );
}

export const getDepartmentByCode = async (code: string, language = "ru", perPage = 5, page = 0) => {
    if (process.env.NODE_ENV === "development" && !!process.env.FAST_REFRESH) {
        return Promise.resolve(language === 'ru' ? departmentResponseMockRu : departmentResponseMockEn);
    }

    return await requestStaffSuggestions({
            [IntranetLayers.Groups]: {
                language: language,
                query: `s_type:department & s_url:${code}`, // только подразделения (департаменты) и точное совпадение по слагу
                perPage: perPage,
                page: page,
                exactMatch: [code],
            }
        }, code
    );
}
